import styled from '@emotion/styled';
import { Box, Paper } from '@mui/material';

export const EventPaper = styled(Paper)({
  width: `calc(50% - 8px)`,
  borderRadius: '10px',
  border: '1px solid #ccc',
  display: 'flex',
  flexDirection: 'column'
});

export const EventHeaderBox = styled(Box)({
  padding: '12px 16px 12px 16px',
  backgroundColor: '#FBFBFC'
});

export const EventDetailsBox = styled(Box)({
  padding: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});
